import { useState } from 'react';
import dayjs from 'dayjs';
import { ModalProps } from '../../../types';
import ModalBase from '..';
import { Alert, Button, Input } from '@piggytechng/component-library';
import { OverideButtonStyle, OverideInputStyle } from '../../../helpers/utils';
import useCustomers from '../../../hooks/useCustomers';
import { verifyAdminPassword } from '../../../helpers/utils/auth-payload';

function ModalReverseAutosave({ modalIsOpen, setIsOpen, userId }: ModalProps & { userId: string }) {
  const [date, setDate] = useState('');
  const [password, setPassword] = useState('');
  const { reverseMultipleAutosave, isLoading } = useCustomers();

  function closeModal() {
    setIsOpen(false);
    setDate('');
    setPassword('');
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!date) {
      Alert.error('Please select a date');
      return;
    }

    if (!password) {
      Alert.error('Please enter admin password');
      return;
    }

    if (!(await verifyAdminPassword(password))) return;

    // Endpoint expects the date as DD-MM-YYYY (e.g. 30-07-2026); the date input gives YYYY-MM-DD
    const formattedDate = dayjs(date).format('DD-MM-YYYY');

    await reverseMultipleAutosave(userId, formattedDate, password, () => {
      closeModal();
    });
  };

  return (
    <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
      <div className="modal-processor">
        <div className="modal-processor__header">
          <h2>Reverse Multiple Autosave</h2>
          <button onClick={closeModal}>&times;</button>
        </div>

        <form className="modal-processor__body" onSubmit={handleSubmit}>
          <p style={{ marginBottom: '20px', color: '#666' }}>
            Select the date to reverse multiple autosaves for this user.
          </p>

          <Input
            {...OverideInputStyle}
            label="Date"
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            placeholder="YYYY-MM-DD"
            required
          />

          <Input
            {...OverideInputStyle}
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />

          <div className="modal-processor__actions">
            <Button
              {...OverideButtonStyle}
              className="modal-processor__actions-resolve"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? 'Processing...' : 'Reverse Autosaves'}
            </Button>
          </div>
        </form>
      </div>
    </ModalBase>
  );
}

export default ModalReverseAutosave;
